import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import {Input} from 'reactstrap';
import jwt_decode from "jwt-decode";
import axios from "axios";
import $ from "jquery";
import Select from 'react-select';
import {css} from "@emotion/core";
import { List } from 'react-virtualized';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import * as moment from "moment";
import ModalD from "react-awesome-modal";
import loadingGif from "../../assets/img/loading.gif";
import {connect}  from  "react-redux";
import {BeatLoader} from "react-spinners";
import {confirmAlert} from 'react-confirm-alert';
import { isApiResponse, isReportAccess, date_range_config, aplloClient,user_activities } from '../../helpers/utils.js';
import MultiCsvReportDownload from '../DownloadReport/MultiCsvReportDownload.jsx';
import MerchantFilter from '../../filters/MerchantFilter.jsx';
import ChainFilter from '../../filters/ChainFilter.jsx';
import StoreFilter from '../../filters/StoreFilter.jsx';
import UtidFilter from '../../filters/UtidFilter.jsx';
import DateRangeFilter from '../../filters/DateRangeFilter.jsx';
import UBCTenderModeFilter from '../../filters/UBCTenderModeFilter.jsx';
import UBCInvoiceRequestFilter from '../../filters/UBCInvoiceRequestFilter.jsx';
const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;

var date_config = date_range_config('0', '0', '2020-02-01','0');
var UBCTransactionTable='';


class UBCTransactionReport extends Component{
    constructor(props) {
        super(props);
        this.state ={
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            dateFromLimit: date_config.start_date_limit,
            dateLimit:date_config.end_date_limit,
            merchantList:[],
            chainList:[],
            merchantID:'',
            chainID:'',
            storeID:'',
            merchantValue:null,
            chainValue:null,
            storeList:[],
            acqBankList:[],
            acqBankValue: null,
            acqBankIds:'',
            issuerBankList:[],
            issuerBankValue:null,
            issuerBankIds:'',
            cityLists:[],
            cityValue:null,
            cityIds:'',
            loading:false,
            is_void:1,
            model_visible : false,
            file_url: '',
            rfile: '',
            merchant_list_box: false,
            chain_list_box: false,
            store_list_box: false,
            acq_bank_list_box: false,
            txnLists:[{value:'Leg1 QR Transaction', label: 'Leg1'},{value:'Leg2 QR Transaction', label: 'Leg2'}],
            txnValue:'',
            txnIds:'',
            is_store_loading: true,
            is_chain_loading: true,
            is_merchant_loading: true,
            txnTypeLists: [{value: 'all', label: 'All'}, {value: 'SALE', label: 'SALE'}, {
                value: 'VOID',
                label: 'VOID'
            }, {
                value: 'REVERSAL',
                label: 'REVERSAL'
            },{
                value: 'FAILED',
                label: 'FAILED'
            }],
            txnTypeIDs: ['SALE'],
            txnTypeValue: [{value: "SALE", label: "SALE"}],
            ciutidList: [],
            ciutidValue: null,
            ciutidIds: '',
            is_utid_loading: true,
            isSettledLists: [{value: 'Settled', label: 'Settled'},{value: 'Unsettled', label: 'Unsettled'},{value: 'Reversal', label: 'Reversal'}, {value: 'Void', label: 'Void'},{value: 'Failed', label: 'Failed'}],
            isSettledIDs: '',
            isSettledValue: null,
            isChange: false,
            is_posbillinput: 0,
            is_prim_id:0,
            listOpen: false,
            headerTitle: "Select [Utid]",
            storeListOpen: false,
            storeHeaderTitle: "Select [Store]",
            object_code:[],
            storeObject:[],
            search_object_code:[],
            fetch_data:false,
            invoice_request:"",
            tenderModeIDs:"",
            invoiceNumber: '',
            CustomerContact: '',
            amountFilterType: 'equal',
            min_amount: '',
            max_amount: ''
        }

    }
    componentWillMount() {
        this.props.currentMenu("unipaynext");
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");
        isReportAccess(AllAccessPermissions, "ubc_txn_report");
        if(decoded.object_type==='Merchant'){
            this.setState({
                merchantID: arrayCode
            })
        }
        if(decoded.object_type==='Chain'){
            this.setState({
                chainID: arrayCode
            })
        }
        if(decoded.object_type==='Store'){
            this.setState({
                storeID: arrayCode
            })
        }

        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
            userType: decoded.userType,
        });
    }

    componentDidUpdate() {
     }
    componentDidMount() {
        this.get_filtered_utid_summary_report(this.state.object_type,this.state.object_code,'');
        //user_activities(0, jwt_decode(localStorage.usertoken)._id, jwt_decode(localStorage.usertoken).firstName+' '+jwt_decode(localStorage.usertoken).lastName, jwt_decode(localStorage.usertoken).email,'utid_summary_report','sparcs')
    }

    get_filtered_utid_summary_report(object_type, object_code, event) {
        var that = this;
        isApiResponse(false)
        var merchants = this.state.merchantID;
        var chains = this.state.chainID;
        var stores = this.state.storeID;
        if(object_type === 'Merchant' && this.state.merchantID===''){
            merchants = object_code;
        }
        if(object_type==='Chain' && this.state.chainID===''){
            chains = object_code;
        }
        if(object_type==='Store' && this.state.storeID===''){
            stores = object_code;
        }
        this.setState({
            active_mids: merchants,
            active_cids: chains,
            active_sids: stores,
            active_bids: this.state.acqBankIds,
            active_cityids: this.state.cityIds,
            active_transaction_type: this.state.txnTypeIDs,
            active_yestSend: this.state.yestSend,
            active_todSend: this.state.todSend,
            active_utid: this.state.ciutidIds,
            active_is_settled: this.state.isSettledIDs,
            active_txnIds: this.state.txnIds,
            active_is_prim_id: this.state.is_prim_id,
            active_is_posbillinput: this.state.is_posbillinput,
        })
        var postData = {
            mids: merchants,
            cids: chains,
            sids: stores,
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            utid: this.state.ciutidIds,
            tenderModeIDs: this.state.tenderModeIDs,
            invoice_request: this.state.invoice_request,
            ci_bill_invoice_no: this.state.invoiceNumber,
            ci_customer_mobile_number: this.state.CustomerContact,
            amountFilterType: this.state.amountFilterType,
            min_amount: this.state.min_amount,
            max_amount: this.state.max_amount,
            report_code:"ubc_txn_report"
        };
        if ($.fn.DataTable.isDataTable('#UBCTransactionTable')) {
            $('#UBCTransactionTable').DataTable().clear().destroy();
        }
        var UBCTransactionTable = $('#UBCTransactionTable').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                "sPaginationType": "numbers",
                "autoWidth": false,
                //"responsive": false,
                "scrollX": true,
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/InternalReport/ubc-transaction-report",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) { //console.log("amondon"); console.log(json);
                        isApiResponse(true)
                        that.setState({
                            isChange: false
                        })
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        isApiResponse(true);
                        alert("Failed to load data. Please try again");
                    },
                    complete: function (data) {
                        isApiResponse(true)
                    },
                },

                columns: [
                    {"data": "merchant_name"},
                    {"data": "chain_name"},
                    {"data": "store_name"},
                    {"data": "utid"},
                    {"data": "city_name"},
                    {"data": "state_name"},
                    {"data": "pin_code"},
                    {"data": "invoice_date"},
                    {"data": "UBC digital Invoice"},
                    {"data": "bill_invoice_number"},
                    {"data": "pos_number"},
                    {"data": "user_phone"},
                    {"data": "transaction_type"},
                    {"data": "upload_date_and_time"},
                    {"data": "amount"},
                    {"data": "eat_in_total"},
                    {"data": "take_out_total"},
                    {"data": "final_amount"},
                    {"data": "cash_tendered"},
                    {"data": "paymentmode"},
                    {"data": "prim_id"},
                    {"data": "mer_store_code"},
                    {"data": "sms_txn_id"},
                    {"data": "sms_delivery_status"},
                    {"data": "sms_triggered_at"},
                    {"data": "sms_delivery_date"},
                    {"data": "reason"},
                    {"data": "last_updated_at"},


                ],
                "columnDefs": [
                    {  render: function (data) {
                            return '<td >'+moment(data).format('D MMM YYYY HH:mm:ss')+'</td>';
                        },
                        "width": "80px",
                        "targets": 13
                    },
                    {  render: function (data) {
                            return "<div class='text-wrap width-80'>" +moment(data).format('D MMM YYYY')+ "</div>";
                        },
                        "width": "80px",
                        "targets": 7
                    },
                    {
                        render: function (data, type, row) {

                            if(row['UBC digital Invoice']===null || row['UBC digital Invoice']==="" || row['UBC digital Invoice'] ==='null') {
                                return '<td ></td>';
                            }
                            else{
                                return '<td ><a href="#" data-code ="' + data + '" data-primid ="' + row['prim_id'] + '">UBC digital Invoice</a> &nbsp;</td>';
                            }

                        },
                        className: "ubc_charge_slip",
                        targets: 8,
                        aTargets: [ -1 ]
                    },
                    {
                        render: function (data, type, full, meta) {
                            if(data===null || data===''|| data ==='null'){
                            data = '';
                            }
                            return "<div class='text-wrap width-150'>" + data + "</div>";
                        },
                        "targets": [0,1,2]
                    },

                ],

            });
        $('#UBCTransactionTable').on('click', 'td.ubc_charge_slip a', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            var code = $(this).data("code");
            //alert(code)
            var acqbank = $(this).data("acqbank");
            var trdate = $(this).data("trdate");
            var prim_id = $(this).data("primid");

            let win=window.open('about:blank','popUpWindowUBCSlip', 'height=500,width=400,left=100,top=100,resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no, status=yes' )
            var perLoad = '<div style="text-align: center" id="loaderDiv"><img src=" '+ loadingGif +' "></div>';
            win.document.write(perLoad)

            $.ajax({
                url:config.get('API_URL')+ "/reports/generate_ubc_slip/?ubc_url="+code+"&acq_bank_name="+acqbank+"&transaction_date="+trdate+"&prim_id="+prim_id,
                type: 'GET',

                beforeSend: function (request) {
                    request.setRequestHeader("Authorization", localStorage.usertoken);
                },
                success: function (response) {
                    that.setState({
                        ubcopened: true,
                        UbcChargeSlipPopup: true,
                        ubcSlipData:response
                    })
                    win.document.close();
                    win.document.write(that.state.ubcSlipData);
                },
                //dataType: 'html'
            })
        })

    }

    UBCTransactionDownloadCheck(e){
        let filters = {
            merchant_codes: this.state.merchantID,
            chain_codes: this.state.chainID,
            store_codes: this.state.storeID,
            end_date: this.state.todSend,
            start_date: this.state.yestSend,
            utids: this.state.ciutidIds,
            paymentmode: this.state.tenderModeIDs,
            transaction_type:this.state.invoice_request,
            ci_bill_invoice_no: this.state.invoiceNumber,
            ci_customer_mobile_number: this.state.CustomerContact,
            amountFilterType: this.state.amountFilterType,
            min_amount: this.state.min_amount,
            max_amount: this.state.max_amount,
            download: 1,
            report_code:"ubc_txn_report",
            user_id: this.state.user_id,

        }
        this.setState({
            filters:filters
        })
        if(this.state.merchantID==='' && this.state.chainID==='' && this.state.storeID==='' && this.state.ciutidIds===''){
            confirmAlert({
            //title: 'Warning',
                message: "Do you really want to download all data for date range: "+this.state.datefromShow+" - "+this.state.dateToShow+" ? This will take some time to download depending on volume of data. Alternatively, please apply a filter.",
                buttons: [{
                    label: 'OK',
                    onClick: () => {
                        this.refs.downloadAllReport.downLoadReport(filters, '/internal_reports/ubc-transaction-report','ubc_txn_report', 30);
                    }
                },
                    {
                        label: 'Cancel',
                    }
                ]
            });
        } else {
            this.refs.downloadAllReport.downLoadReport(filters, '/internal_reports/ubc-transaction-report','ubc_txn_report', 30);
        }
    }
   
    reset_all(e){
        this.refs.daterangeFilter.restDateFilter(date_config.start_date,date_config.end_date,date_config.display_start_date, date_config.display_end_date, date_config.start_date_value,date_config.end_date_value);
        if(this.state.object_type==='Innoviti')
        {
            this.refs.merchantFilter.restMerchantFilter();
            this.refs.reloadChain.getChain(this.state.object_code, 'innoviti', this.state.object_type, this.state.object_code);
            this.refs.reloadStore.getStore(this.state.object_code, 'innoviti', this.state.object_type, this.state.object_code, false,'');
            this.refs.reloadUtid.ci_utid('','','',false,'');
        }
        if(this.state.object_type==='Merchant')
        {
            this.refs.reloadChain.getChain(this.state.object_code, 'merchant', this.state.object_type, this.state.object_code);
            this.refs.reloadStore.getStore(this.state.object_code, 'merchant', this.state.object_type, this.state.object_code,false,'');
            this.refs.reloadUtid.ci_utid(this.state.object_code,'','',false,'');
        }
        if(this.state.object_type==='Chain')
        {
            this.refs.reloadStore.getStore(this.state.object_code, 'chain', this.state.object_type, this.state.object_code,false,'');
            this.refs.reloadUtid.ci_utid('',this.state.object_code,'',false,'');
        }
        if(this.state.object_type==='Store')
        {
            this.refs.reloadUtid.ci_utid('','',this.state.object_code,false,'');
        }
        this.refs.tenderModeFilter.restTenderModeFilter();
        this.refs.reloadTxnStatus.resttxnStatusFilter();
        this.setState({
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            merchantID:'',
            chainID:'',
            storeID:'',
            storeValue:[],
            merchantValue:[],
            chainValue:[],
            acqBankValue: [],
            acqBankIds:'',
            issuerBankValue:[],
            issuerBankIds:'',
            cityValue:[],
            cityIds:'',
            is_void:1,
            file_url: '',
            rfile: '',
            cardGradeValue:[],
            cardGradeIDs:'',
            schemeValue:[],
            schemeIDs:'',
            cardTypeValue:[],
            cardTypeIDs:'',
            txnissuerValue:[],
            txnissuerIDs:'',
            emiIssuerValue:[],
            emiIssuerIDs:'',
            txnTypeIDs: ['SALE'],
            txnTypeValue: [{value: "SALE", label: "SALE"}],
            ciutidValue: [],
            ciutidIds: '',
            isSettledIDs: '',
            isSettledValue: [],
            isChange: false,
            is_posbillinput: 0,
            is_prim_id:0,
            tenderModeIDs:'',
            invoice_request:"",
            invoiceNumber: '',
            CustomerContact: '',
            amountFilterType: 'equal',
            min_amount: '',
            max_amount: '',
            tenderModeValue:[],
            is_fallback: 0,
            traCurrencyValue:[],
            traCurrencyIDs:'',
            issuHomeCurrValue:[],
            issuHomeCurrIDs:'',
            campaignCodeValue:[],
            campaignCodeIDs:'',
            txnIds:'',
            txnValue:[],
        })

        setTimeout(function(){
            this.componentWillMount();
            this.componentDidMount();
        }.bind(this), 200);
    }
    handleDateRange = (todSend, yestSend, datefromShow,dateToShow) =>
    {
        this.setState({
            todSend: todSend,
            yestSend: yestSend,
            datefromShow: datefromShow,
            dateToShow: dateToShow,
            isChange: true,
        });


    }
    handleMerchant = (optionSelected, merchantID) =>
    {
        this.setState({
            merchantID:merchantID,
            isChange: true,
            chainID:'',
            storeID:'',
            ciutidIds: '',
        });
        this.refs.reloadChain.getChain(merchantID, 'merchant', this.state.object_type, this.state.object_code);
        this.refs.reloadStore.getStore(merchantID, 'merchant', this.state.object_type, this.state.object_code,false,'');
        this.refs.reloadUtid.ci_utid(merchantID, '','',false,'');
    }
    handleChain = (optionSelected, chainID) =>
    {
        this.setState({
            chainID:chainID,
            isChange: true,
            storeID:'',
            ciutidIds: '',
        });
        this.refs.reloadStore.getStore(chainID, 'chain', this.state.object_type, this.state.merchantID,false,'');
        this.refs.reloadUtid.ci_utid(this.state.merchantID, chainID,'',false,'');
    }

    handleStore = (storeID) =>
    {
        this.setState({
            storeID:storeID,
            isChange: true,
            ciutidIds: '',

        });
        this.refs.reloadUtid.ci_utid(this.state.merchantID, this.state.chainID,storeID,false,'');
    }
    handleUtid = (utid) =>
    {
        this.setState({
            ciutidIds:utid,
            isChange: true
        });

    }
    handleTxnStatus = (optionSelected, txnStatus) =>
    {
        this.setState({
            invoice_request:txnStatus,
            isChange: true
        });
    }
    handleTenderMode = (optionSelected, tenderModeIDs) =>
    {
        this.setState({
            tenderModeIDs:tenderModeIDs,
            isChange: true
        });
    }
    onChangeInput(e) {
        this.setState({ [e.target.name]: e.target.value, isChange: true });
    }
    render() {
        return(
        
            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title">UBC Transaction Report</h4>
                                        <p className="category"></p>
                                    </div>
                                </div>
                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu">
                                        {/*<SalesMenu></SalesMenu>*/}
                                    </div>
                                </div>
                                <div className = "clearfix"></div>
                                <div className = "content">
                                    <div className="row">
                                        <div className="col-md-12 filter-border-right">
                                        <div className="col-md-2 filter-bottom5 padd-5 date-icon-small">
                                            <div><label> Date Filter: </label></div>
                                            <DateRangeFilter ref="daterangeFilter" onSelectDate = {this.handleDateRange} start_date = {this.state.datefrom} end_date={this.state.dateTo} display_start_date = {this.state.datefromShow} display_end_date = {this.state.dateToShow}
                                                start_date_limit = {this.state.dateFromLimit} end_date_limit = {this.state.dateLimit}/>
                                        </div>
                                        {this.state.object_type ==='Innoviti'?
                                                <div className="col-md-2 filter-bottom5 padd-5">
                                                    <label>Merchants</label>
                                                    <MerchantFilter ref="merchantFilter" onSelectMerchant = {this.handleMerchant} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                    <div className="clearfix"></div>
                                                </div> : null}
                                            {this.state.object_type ==='Innoviti' || this.state.object_type ==='Merchant'?
                                                <div className="col-md-2 filter-bottom5 padd-5">
                                                    <label> Chain </label>
                                                    <ChainFilter ref= "reloadChain" onSelectChain = {this.handleChain} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                    <div className="clearfix"></div>
                                                </div>: null }
                                            {this.state.object_type ==='Innoviti' || this.state.object_type ==='Merchant' || this.state.object_type ==='Chain'?
                                                <div className="col-md-2 filter-bottom5 padd-5" >
                                                    <label> Store: </label>
                                                    <StoreFilter ref= "reloadStore" onSelectStore = {this.handleStore} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                    <div className="clearfix"></div>
                                                </div>: null }
                                            <div className="col-md-2 filter-bottom5 padd-5" >
                                                <label> Utid: </label>
                                                <UtidFilter ref = "reloadUtid" onSelectUtid = {this.handleUtid} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Tender Mode </label>
                                                <UBCTenderModeFilter ref="tenderModeFilter" onSelectTenderMode = {this.handleTenderMode} />
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label>Invoice Request:</label>
                                                <UBCInvoiceRequestFilter ref= "reloadTxnStatus" onSelecttxnStatus = {this.handleTxnStatus} />
                                                <div className="clearfix"></div>
                                            </div>

                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label>Invoice Number: </label>
                                                <Input
                                                    name="invoiceNumber"
                                                    value={this.state.invoiceNumber}
                                                    onChange={this.onChangeInput.bind(this)}
                                                />
                                                <div className="clearfix"></div>
                                            </div>

                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label>Customer Contact: </label>
                                                <Input
                                                    name="CustomerContact"
                                                    value={this.state.CustomerContact}
                                                    onChange={this.onChangeInput.bind(this)}
                                                />
                                                <div className="clearfix"></div>
                                            </div>

                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label>Amount Filter Type: </label>
                                                <select
                                                    name="amountFilterType"
                                                    onChange={this.onChangeInput.bind(this)}
                                                    value={this.state.amountFilterType}
                                                    className="form-control"
                                                >
                                                    <option value="equal">Equal To</option>
                                                    <option value="greater">Greater Than</option>
                                                    <option value="less">Less Than</option>
                                                    <option value="between">Between</option>
                                                </select>
                                            </div>

                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label>
                                                    {this.state.amountFilterType === 'between' ? 'Min Amount:' : 'Amount:'}
                                                </label>
                                                <Input
                                                    name="min_amount"
                                                    value={this.state.min_amount}
                                                    onChange={this.onChangeInput.bind(this)}
                                                />
                                                <div className="clearfix"></div>
                                            </div>

                                            {this.state.amountFilterType === 'between' && (
                                                <div className="col-md-2 filter-bottom5 padd-5">
                                                    <label>Max Amount: </label>
                                                    <Input
                                                        name="max_amount"
                                                        value={this.state.max_amount}
                                                        onChange={this.onChangeInput.bind(this)}
                                                    />
                                                    <div className="clearfix"></div>
                                                </div>
                                            )}


                                    </div>

                                    </div>
                                    <div className="row">
                                        <div className="col-md-5 pull-right">
                                            {this.state.isChange===true?
                                                <span className="apply-notification">Please click on Apply button</span>:null
                                            }
                                            <button type="button" className="primary apply-filter" role="button" disabled={!this.state.isChange} onClick={this.get_filtered_utid_summary_report.bind(this, this.state.object_type,this.state.object_code)}>Apply</button>
                                            &nbsp; &nbsp;<button type="button" className="primary reset-filter" role="button"  onClick={this.reset_all.bind(this)}>Reset</button>
                                        </div>
                                    </div>

                                    <div className="clearfix"></div>
                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>
                                    <div className="">
                                        <a href="#" className="exportButton" role="button" onClick={this.UBCTransactionDownloadCheck.bind(this)}>
                                            <i className="fa fa-download" aria-hidden="true"></i>
                                            Export to CSV
                                        </a>
                                    </div>
                                    <div className="clearfix"></div>
                                    <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                        <table id="UBCTransactionTable" className="table table-striped table-hover">
                                            <thead>
                                                <tr>
                                                    <th>Merchant</th>
                                                    <th>Chain</th>
                                                    <th>Store</th>
                                                    <th>Utid</th>
                                                    <th>City</th>
                                                    <th>State</th>
                                                    <th>Pin Code</th>
                                                    <th width="100px">Invoice Date</th>
                                                    <th>UBC digital Invoice</th>
                                                    <th>Bill Invoice Number</th>
                                                    <th>Pos Number</th>
                                                    <th>User Phone</th>
                                                    <th>Transaction Type</th>
                                                    <th>Upload DateTime</th>
                                                    <th>Amount</th>
                                                    <th>EatInTotal</th>
                                                    <th>TakeOutTotal</th>
                                                    <th>Final Amount</th>
                                                    <th>Cash Tendered</th>
                                                    <th>Payment Mode</th>
                                                    <th>PrimId</th>
                                                    <th>Merchant Store Code</th>
                                                    <th>SMS Txn ID</th>
                                                    <th>SMS Delivery Status</th>
                                                    <th>SMS Triggered At</th>
                                                    <th>SMS Delivery Date</th>
                                                    <th>Reason</th>
                                                    <th>Last Updated Date</th>

                                                </tr>
                                            </thead>
                                            <tbody>

                                            </tbody>
                                        </table>
                                    </div>
                                    <MultiCsvReportDownload ref="downloadAllReport" />
                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
           
             );
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
    currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
  }
  export default connect(null,mapDispatchToProps)( UBCTransactionReport );